(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[297],{

/***/ 20297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content015": function() { return /* binding */ Content015; },
  "default": function() { return /* binding */ Content015_Content015; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/widgets/content/Content015/Content015.module.scss
var Content015_module = __webpack_require__(31447);
var Content015_module_default = /*#__PURE__*/__webpack_require__.n(Content015_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/shared/hooks/index.js + 6 modules
var hooks = __webpack_require__(87367);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/widgets/content/Content015/Item/Item.module.scss
var Item_module = __webpack_require__(85729);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content015/Item/Item.jsx













var DEFAULT_VISIBLE_DESCRIPTION = 145;
var DEFAULT_VISIBLE_LIST = 200;
var Item = function(param) {
    var course = param.course, heading = param.heading, description = param.description, coursesList = param.coursesList, coursesQuantity = param.coursesQuantity, appearance = param.appearance;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var t = (0,translations/* useTranslation */.$)().t;
    var truncatedDescription = (0,react.useMemo)(function() {
        return (0,utils/* truncateText */.aF)(description, DEFAULT_VISIBLE_DESCRIPTION);
    }, [
        description
    ]);
    var truncatedList = (0,react.useMemo)(function() {
        return (0,utils/* truncateText */.aF)(coursesList, DEFAULT_VISIBLE_LIST);
    }, [
        coursesList
    ]);
    var ref = (0,hooks/* useToggle */.OT)(), opened = ref.opened, onOpen = ref.onOpen, onClose = ref.onClose;
    var hover = (0,_object_spread/* default */.Z)({}, isDesktop && coursesList && {
        onMouseOver: onOpen,
        onMouseLeave: onClose
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
        directory: "programs",
        slug: course === null || course === void 0 ? void 0 : course.slug,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: classnames_default()((Item_module_default()).wrapper, (0,_define_property/* default */.Z)({}, (Item_module_default()).grey, appearance === "light"))
        }, hover), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((Item_module_default())["content-inner"], (0,_define_property/* default */.Z)({}, (Item_module_default()).rotate, opened)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Item_module_default())["content-front"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                                    className: (Item_module_default()).title,
                                    color: "dark",
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                    value: truncatedDescription,
                                    className: (Item_module_default()).courses
                                }),
                                coursesQuantity && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Item_module_default())["course-amount"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                            color: "grey",
                                            children: t("course_amount")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                                            className: (Item_module_default()).amount,
                                            appearance: "bold",
                                            color: "brand",
                                            children: coursesQuantity
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Item_module_default())["content-back"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                value: truncatedList,
                                className: (Item_module_default())["course-list"]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Item_module_default()).arrow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (Item_module_default()).icon,
                        name: "arrow_right"
                    })
                })
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content015/Item/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content015/Content015.jsx









var Content015 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var appearance = (ref1 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref1 !== void 0 ? ref1 : "light";
    var ref2;
    var courses = (ref2 = payload === null || payload === void 0 ? void 0 : payload.items) !== null && ref2 !== void 0 ? ref2 : [];
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var prevRef = (0,react.useRef)(null);
    var nextRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Content015_module_default()).wrapper, (Content015_module_default())[appearance]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                className: (Content015_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content015_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (Content015_module_default()).title,
                            children: title
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Content015_module_default())["navigation-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Content015_module_default())["slider-navigation"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: prevRef,
                                        className: classnames_default()((Content015_module_default()).navigation, (Content015_module_default())["navigation-prev"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (Content015_module_default()).icon,
                                            name: "arrow_slider_prev"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: nextRef,
                                        className: classnames_default()((Content015_module_default()).navigation, (Content015_module_default())["navigation-next"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (Content015_module_default()).icon,
                                            name: "arrow_slider_next"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content015_module_default()).slider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SwiperLayout */.OJ, {
                    prevRef: prevRef,
                    nextRef: nextRef,
                    watchOverflow: false,
                    slidesPerView: "auto",
                    spaceBetween: 8,
                    slidesPerGroup: 1,
                    slidesOffsetAfter: 30,
                    children: courses.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (Content015_module_default()).slide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, (0,_object_spread/* default */.Z)({
                                appearance: appearance
                            }, item))
                        }, item.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Content015_Content015 = (Content015);


/***/ }),

/***/ 31447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content015_wrapper__YFw5w","light":"Content015_light__vX0cu","grey":"Content015_grey__vXYq2","header":"Content015_header__3N0A5","title":"Content015_title__Mc_Bp","slider":"Content015_slider__dlRzE","slider-navigation":"Content015_slider-navigation__BRVOL","navigation":"Content015_navigation__cwxe_","navigation-prev":"Content015_navigation-prev__0rLOh","navigation-next":"Content015_navigation-next__K70ZJ","slide":"Content015_slide___Tdp7"};

/***/ }),

/***/ 85729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper___zJpX","grey":"Item_grey__yKkzU","title":"Item_title__8c_Nx","course-list":"Item_course-list__f6RDO","courses":"Item_courses__TUdfq","course-amount":"Item_course-amount__bTS0q","arrow":"Item_arrow__V_Lkj","icon":"Item_icon__iGtCN","content-inner":"Item_content-inner__ukcbg","rotate":"Item_rotate__DQHqH","content-front":"Item_content-front__zsEC0","content-back":"Item_content-back__mW46_"};

/***/ })

}]);